import { TableProps } from "antd";
import { agenciesHeader } from "../../utils/constants/agenciesHeader";

interface AgencyDashboardData {
    name: string;
    totalApplicationCount: number;
    testApplicationCount: number;
    knockedOutApplicationCount: number;
    actualApplicationCount: number;
    approvedApplicationCount: number;
    placementRatio: number;
    targetPremium: number;
    rtuApplicationCount: number;
    rtuApplicationPercentage: number;
    declineApplicationCount: number;
    declineApplicationPercentage: number;
    inProgressApplicationCount: number;
    inProgressApplicationPercentage: number;
    avgThreePsTimeInMinutes: number;
}

interface DashboardDataResponse {
    agencyDashboardDataResp: AgencyDashboardData[];
    totalDashboardDataResp: AgencyDashboardData;
}

export const GetColumnData = (
    dashboardData: DashboardDataResponse
): TableProps<AgencyDashboardData>["columns"] => {
    return Object.keys(dashboardData.totalDashboardDataResp ?? {}).map((keyName, i) => {
        return {
            title: agenciesHeader[i] ?? keyName,
            dataIndex: keyName as keyof AgencyDashboardData,
            key: keyName,
            align: "center",
            width: "170px",
            fixed: i < 2 ? "left" : false,
            onCell: () => ({
                style: {
                    backgroundColor: "red",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    maxWidth: "170px",
                },
            }),
            sorter: (a: AgencyDashboardData, b: AgencyDashboardData) => {

                const isLastRow = (row: AgencyDashboardData) => row.name === dashboardData.totalDashboardDataResp.name;

                if (isLastRow(a) || isLastRow(b)) {
                    return 0; // Don't sort if either is the total row
                }

                const aValue = a[keyName as keyof AgencyDashboardData];
                const bValue = b[keyName as keyof AgencyDashboardData];

                if (typeof aValue === 'number' && typeof bValue === 'number') {
                    return aValue - bValue;
                }

                return String(aValue).localeCompare(String(bValue));
            }
        };
    });
};
